import Proxy from './Proxy';

class FollowUpsProxy extends Proxy {
  /**
   * The constructor for the FollowUpsProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/FollowUps', parameters);
  }

  /**
   * Method used to create follow up
   *
   * @param {Object} data The followUp details.
   *
   * @returns {Promise} The result in a promise.
   */
  create(data) {
    return this.submit('post', `${this.endpoint}`, data);
  }

  /**
   * Method used to update follow up
   *
   * @param {Object} data The followUp details.
   *
   * @returns {Promise} The result in a promise.
   */
  update(data) {
    return this.submit('post', `${this.endpoint}/update`, data);
  }

  /**
   * Method used to fetch follow up details.
   *
   * @param {Object} data data to fetch follow up details
   *
   * @returns {Promise} The result in a promise.
   */
  fetchFollowUps(data) {
    return this.submit('post', `${this.endpoint}/list`, data)
  }


  /**
   * Method used to delete follow up
   *
   * @param {id} id The followUp symptom id.
   *
   * @returns {Promise} The result in a promise.
   */
  remove(id) {
    return this.submit('get', `${this.endpoint}/${id}/delete`);
  }

    /**
   * Resolves one or more alerts.
   *
   * @param {resolution data} data
   */
  resolve(data) {
    return this.submit('post', `${this.endpoint}/resolve`, data);
  }

  /**
   * Method used to fetch follow up details.
   *
   * @param {id} id id to fetch follow up  symptoms details
   *
   * @returns {Promise} The result in a promise.
   */
  getFollowUpSymptoms(id) {
    return this.submit('get', `${this.endpoint}/${id}/symptoms`)
  }

  /**
   * Method used to fetch follow up resolved notes.
   *
   * @param data data  to fetch follow up  resolved notes details
   *
   * @returns {Promise} The result in a promise.
   */
  getResolvedNotes(data) {
    return this.submit('post', `${this.endpoint}/resolved`, data);
  }

}

export default FollowUpsProxy;
